import React, { Component } from "react";
import CaseAPI from "../api/CaseAPI";
import UserAPI from "../api/UserAPI";
import WorkFlowMenuAPI from "../api/WorkFlowMenuAPI";
import { NavLink as Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import _ from "lodash";
import Loading from "../components/shared/Loading";
import StateCountUtil from "../utils/StateCountUtil";
import feather from 'feather-icons';
import { sortByOrder } from "../utils/sortingUtils";
import './DashboardPage.css';

class DashboardPage extends Component {
  state = {
    reload: false,
    menu: null,
    loading: true,
    t: this.props.t
  };

  loadDashboardData = () => {
    let interval = setInterval(()=>{
      let dbData = sessionStorage.getItem("dbdata");
      if(dbData){
        this.setState({
          stats: JSON.parse(dbData)
        });
        clearInterval(interval);
      }
    },1000);
  };

  loadMyCasesData = () => {
    let interval = setInterval(()=>{
      let myDBData = sessionStorage.getItem("mydbdata");
      if(myDBData){
        this.setState({
          myCaseStats: JSON.parse(myDBData)
        });
        clearInterval(interval);
      }
    },1000);
  }

  getStateCount = (stats, stateName, workflowId) => {
    return StateCountUtil.getStateCount(stats, stateName, workflowId);
  };

  getStateIcon = (stats, stateName, workflowId, aItem) => {
    // First try to get icon from stats
    const iconFromStats = StateCountUtil.getStateIcon(stats, stateName, workflowId);
    if (iconFromStats) {
      return iconFromStats;
    }
    
    // Fallback to icon from menu item state configuration
    if (aItem && aItem.workflowStateIcon) {
      return aItem.workflowStateIcon;
    }
    
    // Return null if no icon is found
    return null;
  };


  loadMenuItems = () => {
    WorkFlowMenuAPI.updatedList().then(menueitem => {
      this.setState({ menu: menueitem });
    });
  };

  componentDidMount() {
    this.loadDashboardData();
    this.loadMenuItems();
    this.loadMyCasesData();
    feather.replace();
  }

  componentDidUpdate() {
    feather.replace();
  }

  componentWillMount() {
    feather.replace();
  }

  renderStatistics = () => {
    let { menu, stats, myCaseStats, t } = this.state;

    if (menu) {
      let statistics = [];
      menu.forEach(item => {
        statistics.push(
            <h4 className="page-title" key={item.workflowId+'_'+item.id}>
              {item.name}
            </h4>
        );
        statistics.push(<div key={item.name} className="row">{this.renderStatisticElements(item, stats, myCaseStats, t)}</div>);
      });
      return statistics;
    }
  };

  generateTitle = title => {
    const {t} = this.state;
    var translation = t("caseManagement.viewDetails.stateType."+title);
    if(translation.includes("caseManagement.viewDetails.stateType")){
      return title;
    } else {
      return translation;
    }
  }

  renderIcon(iconCode) {
    if(!iconCode) {
      return "";
    }
    return iconCode.startsWith('fa') || iconCode.startsWith('glyphicon') ? (
      <i className={iconCode} />
    ) : (
      <span style={{ verticalAlign: 'middle', paddingRight: 'inherit' }}>
        <i data-feather={iconCode} />
      </span>
    );
  }

  renderStatisticElements = (item, stats, myCaseStats, t) => {
    let rowElements = [];
    rowElements.push(
        sortByOrder(item.states).map((aItem, i) => (
            <div key={i} className="col-lg-2 col-xs-6">
              <Link
                  to={{
                    pathname: "/protected/cases/" + item.workflowId,
                    search: "?type=" + (aItem.workflowStateName !== '' ? aItem.workflowStateName : aItem.name),
                    state: {
                      workflowId: item.workflowId,
                      workflowIndex: item.id,
                      workFlowName: item.name,
                      exerciseId: item.exerciseId,
                      caseState: aItem.workflowStateName,
                      actions: aItem.actions,
                      caseStateTitle:aItem.name,
                      caseStateId: aItem.id,
                      securePublishing : item.securePublishing
                    }
                  }}
              >
                <div className={"small-box " + aItem.buttonStyle}>
                  <div className="inner">
                  <div className="card">
                    <div className="card-content">
                        <div className="icon-div">
                            {(() => {
                                const icon = this.renderIcon(this.getStateIcon(
                                    (aItem.workflowStateName === 'My_Cases' ? myCaseStats : stats),
                                    (aItem.workflowStateName !== '' ? aItem.workflowStateName : aItem.name),
                                    item.workflowId,
                                    aItem // Pass the aItem to access workflowStateIcon
                                ));
                                return icon || null; // Return the icon or null, but always render the div
                            })()}
                        </div>
                        <div className="details-div">
                            <h3>
                                {this.getStateCount(
                                    (aItem.workflowStateName === 'My_Cases' ? myCaseStats : stats),
                                    (aItem.workflowStateName !== '' ? aItem.workflowStateName : aItem.name),
                                    item.workflowId,
                                )}
                            </h3>
                            <p>{aItem.name}</p>
                        </div>
                    </div>
                </div>

                  </div>
                </div>
              </Link>
            </div>
        )),
    );
    return rowElements;
  };

  render() {
    let { t } = this.state;
    return (
      <div>
        <div className="content-wrapper workflow-dashboard">
          <section className="content-header">
            <h1>{t("dashboard.sectionHeader")}</h1>
          </section>
          <section className="content">{this.renderStatistics()}</section>
        </div>
      </div>
    );
  }
}

export default withTranslation("common")(DashboardPage);